import React, { useState, useEffect, useCallback } from "react";
import Header from "./components/Header";
import Content from "./components/Content";
import { defaultProvider, stark } from "starknet";
import LoadingX3 from "./components/LoadingX3";
import Alert from "./components/Alert";
import { CONTRACT_ADDRESS } from "./constants";

const { getSelectorFromName } = stark;

function App() {
  const [view, changeView] = useState("swap");
  const [tokenABalance, setTokenABalance] = useState(NaN);
  const [tokenBBalance, setTokenBBalance] = useState(NaN);
  const [poolABalance, setPoolABalance] = useState(NaN);
  const [poolBBalance, setPoolBBalance] = useState(NaN);
  const [pendingTransactions, changePendingTransactions] = useState({});
  const [account, changeAccount] = useState("1");

  function newAccount() {
    const randomNumber =
      Math.floor(Math.random() * Number.MAX_SAFE_INTEGER) + 1;
    changeAccount(randomNumber.toString());
  }

  const getTokenBalance = useCallback(async () => {
    async function getTokenABalance() {
      try {
        const tokenABalanceResponse = await defaultProvider.callContract({
          contract_address: CONTRACT_ADDRESS,
          entry_point_selector: getSelectorFromName(
            "get_account_token_balance"
          ),
          calldata: [account, "1"],
        });
        const tokenABalanceHex = tokenABalanceResponse.result[0];
        setTokenABalance(parseInt(tokenABalanceHex, 16));
      } catch (error) {
        console.error(error);
      }
    }

    async function getTokenBBalance() {
      try {
        const tokenBBalanceResponse = await defaultProvider.callContract({
          contract_address: CONTRACT_ADDRESS,
          entry_point_selector: getSelectorFromName(
            "get_account_token_balance"
          ),
          calldata: [account, "2"],
        });
        const tokenBBalanceHex = tokenBBalanceResponse.result[0];
        setTokenBBalance(parseInt(tokenBBalanceHex, 16));
      } catch (error) {
        console.error(error);
      }
    }

    await getTokenABalance();
    await getTokenBBalance();
  }, [account]);

  const getPoolBalance = useCallback(async () => {
    async function getPoolABalance() {
      try {
        const poolABalanceResponse = await defaultProvider.callContract({
          contract_address: CONTRACT_ADDRESS,
          entry_point_selector: getSelectorFromName("get_pool_token_balance"),
          calldata: ["1"],
        });

        const poolABalanceHex = poolABalanceResponse.result[0];
        setPoolABalance(parseInt(poolABalanceHex, 16));
      } catch (error) {
        console.error(error);
      }
    }

    async function getPoolBBalance() {
      try {
        const poolBBalanceResponse = await defaultProvider.callContract({
          contract_address: CONTRACT_ADDRESS,
          entry_point_selector: getSelectorFromName("get_pool_token_balance"),
          calldata: ["2"],
        });

        const poolBBalanceHex = poolBBalanceResponse.result[0];
        setPoolBBalance(parseInt(poolBBalanceHex, 16));
      } catch (error) {
        console.error(error);
      }
    }

    await getPoolABalance();
    await getPoolBBalance();
  }, []);

  useEffect(() => {
    getTokenBalance();
    getPoolBalance();
  }, [getTokenBalance, getPoolBalance]);

  useEffect(() => {
    if (view === "balance") {
      getTokenBalance();
    } else if (view === "liquidity") {
      getPoolBalance();
    }
  }, [view, getTokenBalance, getPoolBalance]);

  console.log();

  return (
    <>
      <div className="h-screen w-screen flex flex-col justify-center	items-center bg-black">
        {!Number.isNaN(tokenABalance) &&
        !Number.isNaN(tokenBBalance) &&
        !Number.isNaN(poolABalance) &&
        !Number.isNaN(poolBBalance) ? (
          <>
            <Header view={view} changeView={changeView} />
            <Content
              view={view}
              tokenABalance={tokenABalance}
              tokenBBalance={tokenBBalance}
              poolABalance={poolABalance}
              poolBBalance={poolBBalance}
              pendingTransactions={pendingTransactions}
              changePendingTransactions={changePendingTransactions}
              account={account}
              newAccount={newAccount}
            />
          </>
        ) : (
          <LoadingX3 />
        )}
      </div>
      <PendingTransactionAlerts
        pendingTransactions={pendingTransactions}
        changePendingTransactions={changePendingTransactions}
      />
    </>
  );
}

function PendingTransactionAlerts({
  pendingTransactions,
  changePendingTransactions,
}: {
  pendingTransactions: any;
  changePendingTransactions: any;
}) {
  return (
    <div className="transition transform fixed z-100 top-0 inset-x-0 pt-2 sm:pt-5 opacity-100 scale-100 translate-y-0 ease-out duration-500 pointer-events-none">
      {Object.keys(pendingTransactions).map((pendingTransaction) => (
        <Alert
          pendingTransaction={pendingTransaction}
          transactionStatus={pendingTransactions[pendingTransaction]}
          removeTransaction={() => {
            const {
              [pendingTransaction]: value,
              ...withoutPendingTransaction
            } = pendingTransactions;
            changePendingTransactions(withoutPendingTransaction);
          }}
        />
      ))}
    </div>
  );
}

export default App;
